import React,{Component} from 'react'
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import AchivementCard from "../AchivementCard.view";


class AchivementSlider extends Component {
    constructor (props) {
        super (props);
        this.slider = null;
        this.handleNext = this.handleNext.bind(this);
    }

    _renderTours(){
        return [1,2,3,4].map((val)=> {
            return (
                <div>
                    <AchivementCard/>
                </div>
            )
        })
    }

    handleNext() {
        if (this.slider) {
            this.slider.slickNext();
        }
    }

    handlePrev() {
        if (this.slider) {
            this.slider.slickPrev();
        }
    }

    render(){
        const settings = {
            dots: true,
            infinite: true,
            nav: false,
            accessibility: false,
            arrows: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            // variableWidth: true,
            touchThreshold: 10,
            autoplay: true,
            // dotsClass:"horizontal-dots"
        }
        return(
            <div className={'achievement'}>
                <Slider ref={c => { this.slider = c; }} {...settings}>
                    {this._renderTours()}
                </Slider>
            </div>
        )
    }
}

export default AchivementSlider